import React from "react";
import { useI18n, LANGS } from "@/lib/i18n";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

/**
 * Standalone language toggle for pages that don't render inside <Layout>
 * (login, register, landing). Mirrors the TopBar dropdown so behavior is
 * identical everywhere.
 */
export default function LanguageToggle({ className = "" }) {
  const { t, lang, setLang } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher"
        className={`rounded-full px-3 h-9 grid place-items-center border border-stone-200 bg-white text-xs font-semibold tracking-wider hover:bg-stone-50 transition ${className}`}
      >
        {LANGS.find((l) => l.id === lang)?.short || "EN"}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuLabel>{t("language")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.id}
            data-testid={`lang-${l.id}`}
            onClick={() => setLang(l.id)}
            className={lang === l.id ? "font-semibold" : ""}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
